import { Builder } from '@builder.io/react'
import { Disclosure } from '@headlessui/react'
import { HeadingClass, HeadingType } from 'enums'
import React from 'react'
import CustomHeading, { headingTypePropObj, headingClassPropObj } from '../common/heading'
interface Faq {
  question: string
  answer: string
}

interface Props {
  faqs: Faq[]
  backgroundColor: string
  headingText: string
  headingTextColor: string
  FaqsQuestionBackgroundColor: string
  faqQuestionColor: string
  FaqsAnswerBackgroundColor: string
  faqAnswerColor: string
  PlusMinusBackgroundColor: string
  PlusMinusColor: string
  headingType: HeadingType
  headingClass: HeadingClass
}

const FAQ = ({
  faqs,
  backgroundColor,
  headingText,
  headingTextColor,
  FaqsQuestionBackgroundColor,
  faqQuestionColor,
  FaqsAnswerBackgroundColor,
  faqAnswerColor,
  PlusMinusBackgroundColor,
  PlusMinusColor,
  headingType,
  headingClass
}: Props) => {
  return (
    <div className="bg-gray-50 py-4" style={{ backgroundColor: backgroundColor || 'transparent' }}>
      <div className="mx-auto max-w-7xl py-0 sm:py-0 lg:px-8">
        <div className="mx-auto max-w-3xl divide-y-2 divide-gray-200">
          <CustomHeading
            classList="text-center pb-2"
            headingClass={headingClass}
            headingType={headingType}
            color={headingTextColor || '#000000'}
          >
            {headingText}
          </CustomHeading>
          <dl className="mt-0 space-y-6 divide-y divide-gray-200">
            {faqs?.map((faq: Faq, i) => (
              <Disclosure as="div" key={i} style={{ backgroundColor: FaqsQuestionBackgroundColor || '#A6C7D1' }}>
                {({ open }) => (
                  <>
                    <dt
                      className="px-5 py-2 text-lg"
                      style={{ backgroundColor: FaqsQuestionBackgroundColor || '#A6C7D1' }}
                    >
                      <Disclosure.Button className="flex w-full items-center justify-between text-left text-gray-400">
                        <span className="break-words text-gray-900" style={{ color: faqQuestionColor || '#004355' }}>
                          {faq.question}
                        </span>
                        <span className="ml-1.5">
                          {open ? (
                            <button
                              type="button"
                              className={'btn-add-minus h-10 w-10'}
                              style={{
                                backgroundColor: PlusMinusBackgroundColor || '#036685',
                                color: PlusMinusColor || 'white',
                                borderColor: PlusMinusBackgroundColor || '#036685'
                              }}
                            >
                              -
                            </button>
                          ) : (
                            <button
                              type="button"
                              className={'btn-add-minus h-10 w-10'}
                              style={{
                                backgroundColor: PlusMinusBackgroundColor || '#036685',
                                color: PlusMinusColor || 'white',
                                borderColor: PlusMinusBackgroundColor || '#036685'
                              }}
                            >
                              +
                            </button>
                          )}
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Disclosure.Panel
                      as="dd"
                      className="px-5 py-2 pr-12 "
                      style={{ backgroundColor: FaqsAnswerBackgroundColor || '#C0D1D6' }}
                    >
                      <p className="break-words text-base text-gray-500" style={{ color: faqAnswerColor || '#000000' }}>
                        {faq.answer}
                      </p>
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            ))}
          </dl>
        </div>
      </div>
    </div>
  )
}

export default FAQ

Builder.registerComponent(FAQ, {
  name: 'FAQ',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'transparent'
    },
    {
      ...headingTypePropObj
    },
    {
      ...headingClassPropObj
    },
    {
      name: 'headingText',
      type: 'text',
      defaultValue: 'FAQs'
    },
    {
      name: 'headingTextColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'FaqsQuestionBackgroundColor',
      type: 'color',
      defaultValue: '#6BA1B3'
    },
    {
      name: 'faqQuestionColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'FaqsAnswerBackgroundColor',
      type: 'color',
      defaultValue: '#C0D1D6'
    },
    {
      name: 'faqAnswerColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'PlusMinusBackgroundColor',
      type: 'color',
      defaultValue: '#036685'
    },
    {
      name: 'PlusMinusColor',
      type: 'color',
      defaultValue: '#ffffff'
    },
    {
      name: 'faqs',
      type: 'list',
      defaultValue: [{ question: 'Whats the best food that we can get?', answer: 'Dog food' }],
      subFields: [
        { name: 'question', type: 'string', defaultValue: 'Whats the best food that we can get?' },
        { name: 'answer', type: 'string', defaultValue: 'Dog food' }
      ]
    }
  ]
})
